import React from 'react';
import { useHistory } from 'react-router-dom';
import './ServiceCard.css'


const ServiceCard = ({service}) => {
    const history = useHistory()
    const handleClick = (id) => {
        history.push('/service/' + id)
    }
    return (
        <div className="col-md-4 text-center mt-4 service-container p-4 mb-4" onClick={() => handleClick(service._id)}>
            <img src={`data:image/png;base64,${service.img.img}`} className="img-fluid mb-3 animation"/>
            <h4>{service.title}</h4>
            <p>{service.description}</p>
        </div>
    );
};

export default ServiceCard;